/*
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited 2024.
 */

import { SxProps } from '@mui/material/styles';

export const orderItemTableV2DetailsCellSX: SxProps = {};
